import * as React from "react";

import { ExtendedFTNode } from "typings/flexFramework/FlexComponent";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

import { LobFormWithTabs } from "components/shared/StorefrontWizard/LobFormWithTabs/LobFormWithTabs";
import { LobQueryRouterv2 } from "components/shared/StorefrontWizard/LobQueryRouter";

export interface WizardForTripsHeroProps {
  wizardLOBs: ExtendedFTNode[];
  wizardFormChildren: React.ReactElement[];
  trackOnChangeTab: (tabName: string, rfrrId?: string) => void;
  context: ExtendedContextStore;
}

export const WizardForTripsHero: React.FC<WizardForTripsHeroProps> = ({
  wizardLOBs,
  wizardFormChildren,
  trackOnChangeTab,
  context,
}) => (
  <>
    <LobQueryRouterv2 lobs={wizardLOBs} />

    <div className="all-y-padding-three SimpleContainer">
      <LobFormWithTabs context={context} lobForms={wizardFormChildren} trackOnChangeTab={trackOnChangeTab} />
    </div>
  </>
);
